import { EventTypes } from "@configuratorware/configurator-frontendgui/App/Constant";
import { isDesignerMode } from "@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Selectors";
import AnalyticsService from "@configuratorware/configurator-frontendgui/App/Services/AnalyticsService";
import { filter, map } from "lodash";

// const customActionsToTrack = {
//   [EventTypes.selected_amounts]: (action, state) => {
//     const { event, ...items } = actionsToTrack[EventTypes.selected_amounts](
//       action,
//       state
//     );
//     return { event, ...items };
//   },
// };
export default class CustomAnalyticsService extends AnalyticsService {
  createMiddleware(dataLayer) {
    return (store) => (next) => (action) => {
      const result = next(action);

      const actionsToTrack = this.getActionsToTrack();

      const nextState = store.getState();

      if (!actionsToTrack[action.type]) {
        // if (action.type) {
        //   dataLayer.push({
        //     items: [
        //       {
        //         item_id,
        //         item_name,
        //         price,
        //         quantity,
        //       },
        //     ],
        //   });
        // }
        return result;
      }
      if (action.type) {
        const {
          configurator: {
            configuration: {
              item: { identifier: item_id, title: item_name } = {},
              customdata = {},
            } = {},
            calculation = {},
          } = {},
        } = nextState || {};
        const quantity = customdata?.selectedAmounts?.[item_id] || 0;
        console.log({
          calculation,
          customdata,
          item_id,
          quantity,
        });
        const price = calculation?.netTotal || 0;
        const data = actionsToTrack[action.type](action, nextState);

        // const ecommerce = {
        //   //  add_to_cart: {
        //   items: [
        //     {
        //       currency: "EUR",
        //       //   item_id,
        //       item_name,
        //       price,
        //       quantity,
        //     },
        //   ],
        //   //  },
        // };
        dataLayer.push({
          ...data,
          //   ecommerce: {
          //     items: [
          //       {
          //         currency: "EUR",
          //         //    item_id,
          //         item_name,
          //         price,
          //         quantity,
          //       },
          //     ],
          //     currency: "EUR",
          //     value: price,
          //   },
          // currency: "EUR",
          // value: price,
          //   ecommerce: {
          //     // currency: "EUR",
          //     // value: price,
          //     add: {
          currency: "EUR",
          value: price,
          items: [
            {
              currency: "EUR",
              price,
              //   item_id,
              item_name,
              //   price,
              quantity,
            },
          ],
          //  },
          // add_to_cart: {
          //   currency: "EUR",
          //   value: price,
          //   items: [
          //     {
          //       //   item_id,
          //       item_name,
          //       //   price,
          //       quantity,
          //     },
          //   ],
          // },
          //   },
        });
      }
      return result;
    };
  }
}
